 <template>
  <div>
    <modal name="create-simple-task" height="auto" @opened="opened">
      <div class="task-modal-head">
        <div class="task-modal-close">
          <a @click="$modal.hide('create-simple-task')"> &times; </a>
        </div>
        <div class="px-4 pt-3 px-md-4 modal-head-description d-flex">
          <div class="write-input">
            <input
              class="write-title"
              type="text"
              v-model="title"
              :placeholder="
                bulk ? $t('task.create.bulkTitle') : $t('task.create.title')
              "
            />
          </div>
        </div>
        <div class="px-4 mt-n3 mb-3">
          <errors :errors="errors" field="title" />
        </div>
        <div class="px-4 px-md-4 modal-description-btn mb-3">
          <button
            class="mx-1 mx-md-1 btn-label"
            v-for="(user, index) in task.users"
            :key="index"
          >
            <span
              class="close-icon-btn"
              v-if="!(personalRoute && user.reference == currentUser.reference)"
              @click="removeEmp(user)"
            >
              ×
            </span>
            {{ user.firstName }} {{ user.lastName }}
          </button>
          <span class="multi-select"></span>
        </div>
        <div class="px-4">
          <errors :errors="errors" field="users" />
        </div>
        <div class="title-calender-w ml-4 mt-2 d-flex common-filter">
          <div class="p-2 icon">
            <i class="far fa-calendar"></i>
          </div>
          <div>
            <d-datepicker
              v-model="task.dueDate"
              :placeholder="$t('task.create.dueDate')"
              :language="fr"
              small
              typeable
            />
          </div>
        </div>
        <div class="commient-bg-color">
          <div class="mt-md-1 uplord-and-submit-btn ml-4">
            <div class="drop-zone">
              <dropzone
                @fileAdded="fileAdded"
                :remove="removeFlag"
                @removeFlag="setRemoveFlag"
                @removeFileFromTask="removeFileFromTask"
              />
            </div>

            <div class="modal-3-text mt-3">
              <textarea
                :placeholder="$t('task.create.description')"
                v-model="task.description"
              >
              </textarea>
              <errors :errors="errors" field="description" />
            </div>
            <div class="mt-md-4 modal-3-save">
              <button class="modal-save-btn" @click="createTask()">
                {{ bulk ? $t("task.create.saveBulkTask") : $t("global.save") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import SelectPure from 'select-pure';
import TimeUtils from '../../utils/TimeUtils';
import Errors from '../../components/error/errors.vue';
import ErrorsHelper from '../../helper/ErrorsHelper';
import TaskHelper from '../../helper/TaskHelper';
import Dropzone from '../task/Dropzone';
import { fr } from 'vuejs-datepicker/dist/locale';

export default {
  props: ['bulk'],

  components: {
    Errors,
    Dropzone,
  },

  async mounted() {
    this.currentUser = this.$store.state.user.informations;

    await this.fetchUsers();
    this.$root.$on('createSimpleTask', () => {
      setTimeout(() => {
        this.fillValues();
      }, 100);
      setTimeout(() => {
        this.populateSelect();
      }, 100);
    });
  },

  data() {
    return {
      editFlag: false,
      usersList: [],
      select: {},
      files: [],
      removeFlag: false,
      selectedEmployees: [],
      requiredFields: ['title'],
      errors: {},
      currentUser: {},
      values: [],
      task: {
        title: '',
        dueDate: '',
        description: '',
        users: [],
        fileName: [],
        createdBy: {},
        statusChangedBy: {},
      },
      fr,
    };
  },

  computed: {
    title: {
      get() {
        return this.task.title;
      },

      set(val) {
        this.task.title = TaskHelper.capitalizeTitle(val);
      },
    },

    personalRoute() {
      return this.$route.path == '/personalTasks';
    },

    whichPlaceholder() {
      return this.personalRoute
        ? this.$t('task.create.addCollaborator')
        : this.$t('task.create.addEmployee');
    },
  },

  methods: {
    opened(e, info) {
      this.reset();
    },

    fillValues() {
      if (this.personalRoute) {
        this.usersList.forEach((u) => {
          if (u.reference == this.currentUser.reference) {
            this.values.push(u.value);
            this.user(this.values);
          }
        });
      }
    },

    populateSelect() {
      TaskHelper.deleteSelectPureIfAny();
      this.select = new SelectPure('.multi-select', {
        options: this.usersList,
        multiple: true,
        placeholder: this.whichPlaceholder,
        autocomplete: true,
        icon: 'fa fa-times',
        inlineIcon: false,
        value: this.personalRoute && this.values,
        onChange: (value) => {
          this.user(value);
        },
        classNames: {
          select: 'select-pure__select',
          dropdownShown: 'select-pure__select--opened',
          multiselect: 'select-pure__select--multiple',
          label: 'select-pure__label',
          placeholder: 'select-pure__placeholder',
          dropdown: 'select-pure__options',
          option: 'select-pure__option',
          autocompleteInput: 'select-pure__autocomplete',
          selectedLabel: 'select-pure__selected-label',
          selectedOption: 'select-pure__option--selected',
          placeholderHidden: 'select-pure__placeholder--hidden',
          optionHidden: 'select-pure__option--hidden',
        },
      });
    },

    user(val) {
      const users = [];
      this.task.users = [];
      this.usersList.forEach((user) => {
        if (val.includes(user.value)) {
          users.push({
            reference: user.reference,
            firstName: user.firstName,
            lastName: user.lastName,
            groupReference: user.groupReference,
            status: this.bulk && 'pending',
          });
        }
      });
      this.task.users = users;
    },

    fetchUsers() {
      const userId = this.currentUser.reference;
      let flag = this.personalRoute; // flag to determine in case of manager (all users or subordinates)
      this.currentUser.permissions.forEach((p) => {
        if (p.groupReference === '_super_admin') {
          flag = true;
          this.employee('/'); // under CEO
        } else {
          this.employee(`/employee/incharge/${userId}`, flag); // under manager
        }
      });
    },

    employee(url, flag) {
      let count = 0;
      this.$services.user.employeeForParticularGroup(url, flag).then((res) => {
        res.data.forEach((user) => {
          this.fillUserList(user, count);
          count++;
        });
      });
    },

    fillUserList(user, count) {
      this.usersList.push({
        value: `${count}`,
        label: `${user.firstName} ${user.lastName}`,
        reference: user.reference,
        firstName: user.firstName,
        lastName: user.lastName,
        groupReference: this.setUserGroupRefernce(user),
      });
      this.$store.dispatch('employeeForTask', this.usersList);
    },

    validateTask() {
      this.errors = {};
      return ErrorsHelper.checkErrors(
        this.requiredFields,
        this.task,
        this.errors,
      );
    },

    setStatusChangesRecord() {
      this.task.statusChangedBy.userReference = this.currentUser.reference;
      this.task.statusChangedBy.status = 'pending';
      this.task.statusChangedBy.firstName = this.currentUser.firstName;
      this.task.statusChangedBy.lastName = this.currentUser.lastName;
      this.task.statusChangedBy.timeStamp = new Date().toISOString();
    },

    setUserGroupRefernce(user) {
      const groupReferences = [];
      user.permissions.forEach((p) => {
        groupReferences.push(p.groupReference);
      });
      return groupReferences;
    },

    formatedDueAndCreationDates() {
      const today = new Date();
      const dueDate = this.task.dueDate;
      this.task.createdBy.creationDate = TimeUtils.formatDateString(today);
      this.task.dueDate =
        this.task.dueDate && TimeUtils.formatDateString(dueDate);
    },

    fileAdded(files) {
      this.files = files;
    },

    uploadFile(data) {
      this.$services.task.uploadFile(data).then((res) => {
        if (res.status == 200) {
          this.removeFlag = true;
        }
      });
    },

    removeFileFromTask(name) {
      const files = this.files.filter(file => file.name != name);
      this.files = files;
    },

    setRemoveFlag(flag) {
      this.removeFlag = flag;
    },

    pushInArray() {
      const obj = {
        task: this.task,
        comments: [],
      };
      this.$emit('pushInTasksArray', obj);
    },

    async createTask() {
      if (this.validateTask()) {
        this.task.createdBy.createdById = this.currentUser.reference;
        this.task.createdBy.firstName = this.currentUser.firstName;
        this.task.createdBy.lastName = this.currentUser.lastName;
        this.task.bulk = this.bulk;
        this.task.status = 'pending';
        this.task.path = this.$route.path;
        this.formatedDueAndCreationDates();
        this.setStatusChangesRecord();
        if (this.files.length) {
          const form = new FormData();
          const time = new Date().valueOf().toString();
          const unique = time.slice(time.length / 2, time.length - 1);
          this.files.forEach((file) => {
            form.append('file', file, unique.concat(file.name));
            this.task.fileName.push(unique.concat(file.name));
          });
          await this.uploadFile(form);
        }
        this.$services.task.createTask(this.task).then((res) => {
          if (res.status == 200) {
            this.$modal.hide('create-simple-task');
            this.$miniToastr.success('Vous avez créer une tâche.');
            this.task.reference = res.data.reference;
            this.pushInArray();
          } else {
            this.$miniToastr.error('Il y a eu un petit problème #64518');
          }
        });
      }
    },

    reset() {
      this.errors = {};
      this.task.title = '';
      this.task.dueDate = '';
      this.task.description = '';
      this.task.users = [];
      this.files = [];
      this.task.fileName = [];
      this.task.reference = '';
    },

    removeEmp(user) {
      const users = this.task.users.filter(u => u.reference != user.reference);
      this.task.users = users;
      let value = '';
      this.usersList.forEach((u) => {
        if (u.reference == user.reference) {
          value = u.value;
        }
      });
      const index = this.select._config.value.indexOf(value);
      this.select._config.value.splice(index, 1);
      TaskHelper.removeClassFromDiv(value);
    },
  },
};
</script>
<style lang="scss">
.drop-zone {
  width: 92%;
}
.task-modal-head {
  position: relative;
  min-height: 550px;
  height: 550px;
  overflow-y: auto;
  .task-modal-close {
    position: absolute;
    right: 15px;
    a {
      font-size: 30px;
      cursor: pointer;
      font-weight: 700;
    }
  }
  .main-title-modal {
    p {
      font-family: "SF-Pro-Text";
      color: #212529;
      font-size: 14px;
      @media (min-width: 320px) and (max-width: 600px) {
        font-size: 12px;
      }
    }
  }
  .modal-head-description {
    .description-unorder {
      margin: 0;
      padding: 0;
    }
    li {
      display: inline-block;
      margin-right: 5px;
      ul {
        padding-left: 25px;
        li {
          padding: 0px;
          margin: 0px;
        }
      }
      h3 {
        font-size: 26px;
        font-family: "SF-Pro-Text";
        color: #212529;
        @media (min-width: 320px) and (max-width: 600px) {
          font-size: 17px;
        }
      }
      span {
        display: inline-block;
        margin-bottom: 10px;
      }
    }
  }

  .modal-description-pera {
    background-color: #f6f8ff;
    padding: 20px 0;
    p {
      font-size: 16px;
      font-family: "SF-Pro-Text";
      color: #212529;
      @media (min-width: 320px) and (max-width: 600px) {
        font-size: 14px;
      }
    }
  }
  .modal-comment-section {
    box-shadow: 0 0 2px 0 #b9bbd1;
    margin-bottom: 7px;
    padding: 18px 0;
    .modal-comment-profile {
      background-color: #b9bbd1;
      height: 60px;
      width: 60px;
      display: flex;
      align-items: center;
      text-align: center;
      justify-content: center;
      border-radius: 60px;
      margin-top: -1px;
      margin-bottom: 12px;
      @media (min-width: 320px) and (max-width: 600px) {
        height: 40px;
        width: 40px;
        border-radius: 40px;
        margin: 10px 10px 0 0;
      }
      p {
        margin: 0;
        font-size: 20px;
        color: #fff;
        font-family: "SF-Pro-Text";
        @media (min-width: 320px) and (max-width: 600px) {
          font-size: 15px;
        }
      }
    }
    .modal-comment-text {
      width: 85%;
      margin-left: 20px;
      @media (min-width: 320px) and (max-width: 600px) {
        margin-left: 5px;
      }
      h3 {
        margin: 0;
        font-size: 20px;
        font-family: "SF-Pro-Text";
        color: #303778;
        @media (min-width: 320px) and (max-width: 600px) {
          font-size: 16px;
        }
      }
      p {
        text-align: justify;
        line-height: normal;
        color: #212529;
        font-family: "SF-Pro-Text";
        margin: 0;
        @media (min-width: 320px) and (max-width: 600px) {
          font-size: 12px;
        }
      }
      textarea {
        width: 100%;
        height: 100px;
        border-radius: 4px;
        border: solid 1px #becad6;
        resize: none;
        outline: none;
        padding: 10px;
        @media (min-width: 320px) and (max-width: 600px) {
          margin-bottom: 20px;
        }
      }
    }
    .comment-submit-btn {
      background-color: #4f78e1;
      height: 35px;
      color: #fff;
      margin-top: 10px;
      font-family: "SF-Pro-Text";
      outline: none;
      padding: 4px 15px;
      border: none;
      margin-left: 10px;
      border-radius: 3px;
    }
  }
}
.modal-description-btn {
  display: flex;
  flex-wrap: wrap;
  .btn-label {
    background-color: #e8e9f0;
    display: inline-block;
    padding: 4px 40px 4px 20px;
    border: 0;
    border-radius: 3px;
    font-family: "SF-Pro-Text";
    color: #303778;
    font-weight: 500;
    font-size: 14px;
    outline: none;
    height: 35px;
    margin-bottom: 10px;
    position: relative;
    @media (min-width: 320px) and (max-width: 600px) {
      font-size: 12px;
    }
    .close-icon-btn {
      position: absolute;
      right: 12px;
      top: 0;
      width: 15px;
      line-height: 35px;
      text-align: center;
      font-size: 15px;
      font-weight: 700;
      border-left: 1px solid #d8cfcf;
      border-radius: 0;
      height: 35px;
      padding-left: 8px;
      color: #9e8d8d;
    }
  }
}
.select-pure__select {
  align-items: center;
  background-color: #e8e9f0;
  font-family: "SF-Pro-Text";
  color: #212529;
  border-radius: 3px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  justify-content: left;
  min-height: 35px;
  position: relative;
  transition: 0.2s;
  padding: 4px 20px;
  width: 200px;
  justify-content: center;
}

.select-pure__options {
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  box-sizing: border-box;
  color: #363b3e;
  display: none;
  left: 0;
  max-height: 221px;
  overflow-y: scroll;
  position: absolute;
  top: 50px;
  width: 100%;
  z-index: 100;
}

.select-pure__select--opened .select-pure__options {
  display: block;
}

.select-pure__option {
  background: #fff;
  border-bottom: 1px solid #e4e4e4;
  box-sizing: border-box;
  height: 44px;
  line-height: 25px;
  padding: 10px;
}

.select-pure__option--selected {
  color: #e4e4e4;
  cursor: initial;
  pointer-events: none;
}

.select-pure__option--hidden {
  display: none;
}

.select-pure__selected-label {
  background: #5e6264;
  border-radius: 4px;
  color: #fff;
  cursor: initial;
  display: none;
  margin: 5px 10px 5px 0;
  padding: 3px 7px;
}

.select-pure__selected-label:last-of-type {
  margin-right: 0;
}

.select-pure__selected-label i {
  cursor: pointer;
  display: inline-block;
  margin-left: 7px;
}

.select-pure__selected-label i:hover {
  color: #e4e4e4;
}
.write-input {
  width: 97%;
  ::placeholder {
    color: #707070;
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #707070;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #707070;
  }
}
.write-title {
  border: none;
  font-size: 25px;
  margin-bottom: 15px;
  outline: none !important;
  font-family: "SF-Pro-Text";
  color: #707070;
  font-weight: 700;
  width: 97%;
}

.select-pure__autocomplete {
  background: #f9f9f8;
  border-bottom: 1px solid #e4e4e4;
  border-left: none;
  border-right: none;
  border-top: none;
  box-sizing: border-box;
  font-size: 16px;
  outline: none;
  padding: 10px;
  width: 100%;
}
.common-filter {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 3px;
  input {
    background-color: #fff !important;
    border: none !important;
  }
  .icon {
    i {
      padding-left: 7px;
    }
  }
}
.title-calender-w {
  width: 200px;
}
.modal-3-text {
  textarea {
    width: 92%;
    height: 120px;
    resize: none;
    outline: none;
    border: 1px solid #becad6;
    border-radius: 4px;
    padding: 15px;
    font-family: "SF-Pro-Text";
  }
}
.modal-3-save {
  text-align: center;
  .modal-save-btn {
    background-color: #4f78e2;
    padding: 7px 30px;
    display: inline-block;
    border: none;
    color: #fff;
    border-radius: 4px;
    font-family: "SF-Pro-Text";
    outline: none !important;
    @media (min-width: 320px) and (max-width: 600px) {
      margin-top: 20px;
    }
  }
}
/* .select-pure__placeholder--hidden	{
  display: none;
} */
</style>
